<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Minhas turmas</span>
      <span class="titulo-contexto">Turmas em que você está vinculado como catequista. Escolha uma para lançar frequência.</span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar" *ngIf="turmas.length">
      <div class="filtro-turma-full">
        <app-autocomplete
          rotulo="Turma"
          placeholder="Digite parte do nome ou o ano"
          [opcoes]="opcoesTurma"
          [selecionadoId]="turmaFiltroId"
          (selecionadoIdChange)="turmaFiltroId = $event"
          [permiteTodos]="true"
          rotuloTodos="Todas as turmas"
          msgSemResultado="Nenhuma turma encontrada"
        ></app-autocomplete>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="turmasExibidas.length">
      <table class="smart-table minhas-turmas-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Turma" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Turma</th>
            <th class="col-acoes col-acoes--icones th-acoes">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of turmasExibidas; trackBy: trackByTurmaId">
            <td class="cel-turma-stacked" data-label="Turma">
              <div class="turma-nome"><strong>{{ t.nome }}</strong></div>
              <div class="turma-horario">{{ textoHorarioTurma(t) }}</div>
            </td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  appearance="outline"
                  status="success"
                  size="small"
                  class="btn-acao"
                  (click)="irFrequencia(t.id)"
                  title="Frequência"
                  aria-label="Abrir frequência desta turma"
                >
                  <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
                </button>
                <button
                  type="button"
                  nbButton
                  appearance="outline"
                  status="warning"
                  size="small"
                  class="btn-acao"
                  (click)="irFaltasConsolidado(t.id)"
                  title="Faltas consolidadas por matriculado"
                  aria-label="Abrir consolidado de faltas desta turma"
                >
                  <nb-icon pack="eva" icon="bar-chart-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-lista-vazia
      *ngIf="!turmasExibidas.length"
      icone="briefcase-outline"
      [filtrado]="turmas.length > 0 && temFiltro"
      mensagem="Nenhuma turma vinculada ao seu usuário. Peça a um administrador para associar suas turmas."
      mensagemFiltrado="Nenhuma turma casa com o recorte atual."
      (verTodos)="limparFiltro()"
    ></app-lista-vazia>
  </nb-card-body>
</nb-card>
